import { useSelector } from "react-redux";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { selectCSVFile, selectExistingCsvFilePath } from "../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice";
import { useToastify } from "../../library/toastify/toast-provider";

export const useIsRequiredFileValidation = () => {
    
    const { isSalaryRank } = useProposalTypeData();
    const csvFile = useSelector(selectCSVFile)
    const existingCsvFilePath = useSelector(selectExistingCsvFilePath)
    const { showToastNotify } = useToastify();

    const isHasAttachedFile = () => {
        if(isSalaryRank && !csvFile && !existingCsvFilePath) {
            showToastNotify("Salary Rank requires a file attachment before submission.", "warning");
            return false;
        }
        return true
    }

    return {
        isHasAttachedFile
    }
}